module.exports = __webpack_public_path__ + "img/podeAssistir.b8d0475e.png";